var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('asc-navbar-button',{attrs:{"icon":"mdi-account","primary-items":_vm.getItems,"width":250,"text":_vm.getInitials}})}
var staticRenderFns = []

export { render, staticRenderFns }